import React from "react";
import { Check } from "lucide-react";

export const PHASES = [
  { n: 1, title: "Performance Analysis", short: "Analysis" },
  { n: 2, title: "Cause Analysis", short: "Causes" },
  { n: 3, title: "Intervention & ADDIE", short: "Intervention" },
  { n: 4, title: "Implementation", short: "Implement" },
  { n: 5, title: "Change Management", short: "Change" },
  { n: 6, title: "Evaluation of Results", short: "Evaluate" },
];

export default function Stepper({ current, onSelect }) {
  return (
    <div className="w-full overflow-x-auto border-b border-slate-200 bg-white sticky top-16 z-30 px-4 sm:px-6 py-4">
      <div className="flex items-center min-w-max gap-1">
        {PHASES.map((p, i) => {
          const isActive = current === p.n;
          const isDone = current > p.n;
          return (
            <React.Fragment key={p.n}>
              <button
                data-testid={`stepper-phase-${p.n}`}
                onClick={() => onSelect(p.n)}
                className="flex items-center gap-2 group"
              >
                <span
                  className={`h-8 w-8 rounded-full flex items-center justify-center text-sm font-semibold border-2 transition-colors ${
                    isActive
                      ? "bg-emerald-500 border-emerald-500 text-white"
                      : isDone
                      ? "bg-emerald-100 border-emerald-500 text-emerald-600"
                      : "bg-white border-slate-300 text-slate-400 group-hover:border-slate-400"
                  }`}
                >
                  {isDone ? <Check className="h-4 w-4" /> : p.n}
                </span>
                <span
                  className={`text-sm whitespace-nowrap ${
                    isActive ? "text-emerald-600 font-semibold" : isDone ? "text-slate-600 font-medium" : "text-slate-400 font-medium"
                  }`}
                >
                  {p.title}
                </span>
              </button>
              {i < PHASES.length - 1 && (
                <div className={`h-0.5 w-8 mx-1 ${isDone ? "bg-emerald-400" : "bg-slate-200"}`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
